(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image/assets/javascripts/image-helpers.js') >= 0) return;  svs.modules.push('/components/content/image/assets/javascripts/image-helpers.js'); 
'use strict';

function registerHelpers(hbs, config) {
  hbs.registerHelper('contentImageSrcset', function(context) {
    var srcset = [];
    var imageUrl = config.options.cdn2 + context.url;
    var availableWidths = context.availableWidths || [];

    availableWidths.forEach(function(width) {
      srcset.push(imageUrl.replace('{width}', width) + ' ' + width + 'w');
    });

    return new hbs.SafeString(srcset.join(','));
  });

  hbs.registerHelper('contentImageHeight', function(context) {
    if (context.height && context.width) {
      return context.height / context.width * 100;
    }
    return 43.75;
  });

  hbs.registerHelper('contentImageFallback', function(context) {
    function isAbsoluteUrl(url) {
      return url && url.indexOf('http') === 0;
    }

    var largestSize =
        context.availableWidths &&
        context.availableWidths.length > 0 ?
        context.availableWidths[context.availableWidths.length - 1] :
        1280;

    var url = isAbsoluteUrl(context.url) ? context.url : config.options.cdn2 + context.url;

    return url.replace('{width}', context.fallbackSize || largestSize);
  });
}

if (svs.isServer) {
  registerHelpers(require('hbs'), require('trinidad-core').core.config);
} else {
  registerHelpers(Handlebars, { options: svs.core.config.data.svsconfig });
}


 })(window);